export const isMobileBrowser = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator?.userAgent);

export const isTouchEnabled = () => navigator?.maxTouchPoints > 0;
